import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

export const createReview = createAsyncThunk(
  "/review/createReview",
  async (reviewData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.serverBaseUrl + "api/review",
        { reviewData },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const fetchReviews = createAsyncThunk(
  "/review/fetchReviews",
  async (courseId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + `api/review/${courseId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);
export const fetchAllReviews = createAsyncThunk(
  "/review/fetchAllReviews",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + `api/review/allreview`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

const reviewSlice = createSlice({
  name: "reviewSlice",
  initialState: {
    loading: false,
    error: null,
    reviews: [],
    allreview: [],
  },
  reducers: {
    removeReview: (state, action) => {
      state.reviews = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch all reviews
      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.allreview = action.payload;
      })
      .addCase(fetchAllReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create new course
      .addCase(createReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReview.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews.unshift(action.payload);
      })
      .addCase(createReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { removeReview } = reviewSlice.actions;
export default reviewSlice.reducer;
